exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-tab[data-v-bd8535c2]{color:#fff!important;background-color:#409eff}.tab-item[data-v-bd8535c2]{text-align:center;line-height:25px;margin-right:10px;font-size:14px!important;width:25px;cursor:pointer;color:#d9d9d9}", ""]);

// exports
